import { Button, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, useToast } from '@chakra-ui/react'
import  { useRef } from 'react'
import { closeDeleteModal } from 'src/redux/features/question/questionSlice'
import { useAppDispatch, useAppSelector } from 'src/redux/hooks'
import { deleteQuestion } from 'src/view-models/Question'

const DeleteModal = () => {
    const dispatch = useAppDispatch()
    const toast = useToast()
    const {isOpenDelete,questionId} = useAppSelector((state)=>state.question)
    const finalRef = useRef(null)

    const handleDelete = async () => {
        const response = await deleteQuestion(questionId!,toast,dispatch)
        if(response.status === true) {
          handleClose()
        } 
      }

    const handleClose = () => {
        dispatch(closeDeleteModal())
    }

  return (
    <Modal finalFocusRef={finalRef} isOpen={isOpenDelete} onClose={handleClose}>
        <ModalOverlay 
        />
        <ModalContent>
          <ModalHeader>Suprimer Question</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Êtes-vous sûr de vouloir supprimer ceci Question?</Text>
          </ModalBody>

          <ModalFooter >
            <HStack gap={4} >
              <Button colorScheme='red' onClick={handleDelete}>Suprimer</Button>
              <Button colorScheme='blue' mr={3} onClick={handleClose}>
                Fermer
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
  )
}

export default DeleteModal